import React from 'react';

const BannerDom = (props) => {
  const bannerUrl = props && props.url ? props.url + '?imageslim' : '';
  if (bannerUrl) {
    return (
      <div className="banner-wrapper margin-top-65">
        <img src={bannerUrl} alt="banner" className="banner" />
      </div>
    )
  } else {
    return <div className="margin-top-65"></div>;
  }
}

export default BannerDom;
